export const featureName = 'FEATURE_NAME';